import { ComponentType, FC } from "react";

import { Box, Card, Pressable, Text, VStack } from "@/components/ui";

/* ── Types ─────────────────────────────────────── */

interface ProjectCardProps {
  description: string;
  icon: ComponentType<{ color?: string; size?: number }>;
  name: string;
  onPress: () => void;
}

/* ── Component ─────────────────────────────────── */

/** Tile for one public sector project, laid out like a launch `SimulationCard`. */
const ProjectCard: FC<ProjectCardProps> = ({
  description,
  icon: Icon,
  name,
  onPress,
}) => (
  <Box className="h-full">
    <Pressable className="h-full" onPress={onPress}>
      <Card className="relative border border-outline-200 rounded-2xl p-0 overflow-hidden h-full hover:border-outline-300 hover:shadow-soft-2 hover:-translate-y-0.5 transition-all duration-300">
        <VStack className="h-full">
          <Box className="w-full h-32 bg-primary-50 items-center justify-center">
            <Icon color="rgb(var(--color-primary-500))" size={48} />
          </Box>
          <VStack className="p-5 flex-1">
            <Text className="text-sm font-semibold text-typography-900 mb-1">
              {name}
            </Text>
            <Text className="text-xs text-typography-500 line-clamp-2">
              {description}
            </Text>
          </VStack>
        </VStack>
      </Card>
    </Pressable>
  </Box>
);

export default ProjectCard;
